class Config {
  public environment: string;
  public defaultLang: string;
  public publicPath: string;
  public translationPath: string;
  public backendBasePath: string;
  public imageBasePath: string;
  public shortenerUrl: string;
  public homeUrl: string;
  public shareBasePath: string;


  constructor() {
    console.debug("Environment", import.meta.env.VITE_ENVIRONMENT);
    this.environment = import.meta.env.VITE_ENVIRONMENT;
    this.defaultLang = import.meta.env.VITE_DEFAULT_LANG;
    this.publicPath  = import.meta.env.BASE_URL;
    this.translationPath  = import.meta.env.VITE_TRANSLATION_PATH;
    this.backendBasePath = import.meta.env.VITE_BACKEND_BASE_PATH;
    this.imageBasePath = import.meta.env.VITE_IMAGE_BASE_PATH;
    this.shortenerUrl = import.meta.env.VITE_SHORTENER_URL;
    this.homeUrl = import.meta.env.VITE_HOME_URL;
    this.shareBasePath = import.meta.env.VITE_SHARE_BASE_PATH;
    console.debug(this);
  }
}
export const config = new Config();